import { useContext, useEffect, useState } from "react"
import { Col, Row } from "react-bootstrap"
import Get from "../../api/Get"
import Post from "../../api/Post"
import Put from "../../api/Put"
import { PACIENTERELACION_GET_ALL, PACIENTERELACION_SAVE, PACIENTERELACION_UPDATE } from "../../api/Routes"
import ComponentModalErrorSever from "../../components/ComponentModalErrorSever"
import { authContext } from "../../context/AuthContext"
import LoadingList from "../../loader/LoadingList"
import { toBool } from "../../utils/toBool"
import AddEstadoCivil from "./estadocivil/AddEstadoCivil"
import EstadoCivilList from "./estadocivil/EstadoCivilList"

function TipoPacienteIndex(){

    //Parametros para actualizar la tabla
    const [items, setItems] = useState([])
    const [initialValues, setInitialValues] = useState({name:''})
    const [loading, setLoading] = useState(false)

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)

    useEffect(() => {
        setLoading(true)

        Get({url: PACIENTERELACION_GET_ALL, access_token: auth.data.access_token})
        .then((resp) => {
            setItems(resp.data.content)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [])

    const agregar = (values) => {
        values.active = true;
        values.companies = [auth.data.company]
        setLoading(true)
        Post({url: PACIENTERELACION_SAVE, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {
            setItems(prev=>[...prev, response.data.data])
            setInitialValues({name:''})
            setLoading(false)
        })                
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }

    const editar = (values) =>{
        
        if(toBool(values.active)){
            values.companies.push(auth.data.company)
        }else{
            let arr = values.companies.filter(el => el.id !== auth.data.company.id)
            values.companies = arr
        }        

        Put({url: PACIENTERELACION_UPDATE, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {
            //ok         
        })                
        .catch((error) => {
            setLoading(false)        
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    return(<>
        {loading && <LoadingList  />}

        <div className="body">
            
            <Row>
                <Col xs="6" md="6">
                    {!loading && <AddEstadoCivil agregar={agregar} initialValues={initialValues} title="Añadir nuevo tipo paciente" />}
                </Col>
                <Col xs="6" md="6">
                    <EstadoCivilList items={items} 
                        editar={editar}
                        auth={auth}
                        url_update={PACIENTERELACION_UPDATE}
                    />
                </Col>
            </Row>
        </div>
        <ComponentModalErrorSever 
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
        />
    </>)
}

export default TipoPacienteIndex